import { API_BASE_URL, USE_FEDERATED_AUTH } from 'config';
import { Login, LoginContext } from '../types';

export type Role = {
  id: number;
  name: string;
};

export type Module = {
  id?: number;
  name?: string;
  key?: number;
};

export type OrganizationSettings = {
  [key: string]: unknown;
};

export type UserDto = {
  id: string;
  name: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  avatarColor: string;
  organizationId: number;
  organizationName: string;
  organizationTypeId: number;
  organizationIsAutoStyleNumberOn: boolean;
  organizationIsUniqueStyleNumber: boolean;
  organizationIsStyleNumberGeneratorActive: boolean;
  roles: Array<Role>;
  modules: Array<Module>;
  organizationSettings: OrganizationSettings | null;
};

const mapUserDtoToLogin = (user: UserDto): Login => {
  if (!user) {
    return null;
  }
  const loginContext: LoginContext = {
    id: user.id,
    name: user.name,
    organizationType: user.organizationTypeId,
    organizationName: user.organizationName,
    email: user.email,
    roleNames: user.roles.map(role => role.name),
    designerOrganizationName: user.organizationName,
    designerOrganizationId: user.organizationId,
    brands: undefined,
    organizationId: user.organizationId,
    signUpDate: undefined,
    planType: undefined,
    planTier: undefined,
    platformNewsletterSubscription: undefined,
    inviteCode: undefined,
  };
  return {
    loginContext,
    user: null,
    token: null,
  };
};

export const fetchLogin = async (accessToken: string): Promise<Login> => {
  if (!(accessToken && USE_FEDERATED_AUTH)) {
    return {};
  }
  const response = await fetch(`${API_BASE_URL}/api/user`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Failed to fetch user: ${response.status} ${response.statusText} ${errorText}`);
  }

  const data: UserDto = await response.json();
  return mapUserDtoToLogin(data);
};
